var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("fg-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.modelValidations.name,
                        expression: "modelValidations.name"
                      }
                    ],
                    attrs: {
                      required: true,
                      "for-input": "name",
                      type: "text",
                      name: "name",
                      id: "name",
                      label: "Name",
                      placeholder: "Enter name",
                      error: _vm.errors.first("name"),
                      "data-vv-as": "name"
                    },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$route.params.id !== undefined
                    ? _c("fg-input", { attrs: { label: "Email" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.model.email))])
                      ])
                    : _c("fg-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.modelValidations.email,
                            expression: "modelValidations.email"
                          }
                        ],
                        attrs: {
                          required: _vm.$route.params.id === undefined,
                          "for-input": "email",
                          type: "email",
                          name: "email",
                          id: "email",
                          label: "Email",
                          placeholder: "Enter email",
                          error: _vm.errors.first("email"),
                          "data-vv-as": "email"
                        },
                        model: {
                          value: _vm.model.email,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "email", $$v)
                          },
                          expression: "model.email"
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.first("password") }
                    },
                    [
                      _c("label", [_vm._v("Password *")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.modelValidations.password,
                            expression: "modelValidations.password"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.password,
                            expression: "model.password"
                          }
                        ],
                        ref: "confirmed:password",
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          name: "password",
                          id: "password",
                          label: "password",
                          placeholder: "Enter password",
                          error: _vm.errors.first("password"),
                          "data-vv-as": "password",
                          "aria-describedby": "addon-right addon-left"
                        },
                        domProps: { value: _vm.model.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.model, "password", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("infoBlock"),
                      _vm._v(" "),
                      _vm._t("helpBlock", [
                        _vm.errors.first("password")
                          ? _c(
                              "div",
                              {
                                staticClass: "text-danger invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("password")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("fg-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.modelValidations.passwordConfirmation,
                        expression: "modelValidations.passwordConfirmation"
                      }
                    ],
                    attrs: {
                      required: _vm.$route.params.id === undefined,
                      "for-input": "passwordConfirmation",
                      type: "password",
                      name: "passwordConfirmation",
                      id: "passwordConfirmation",
                      label: "password confirmation",
                      placeholder: "Enter Password Confirmation",
                      error: _vm.errors.first("passwordConfirmation"),
                      "data-vv-as": "password confirmation"
                    },
                    model: {
                      value: _vm.fakeModel.passwordConfirmation,
                      callback: function($$v) {
                        _vm.$set(_vm.fakeModel, "passwordConfirmation", $$v)
                      },
                      expression: "fakeModel.passwordConfirmation"
                    }
                  }),
                  _vm._v(" "),
                  _c("save-data-button", {
                    attrs: {
                      disabled: _vm.saveButtonData.isLoading,
                      "is-create": _vm.$route.params.id === undefined,
                      state:
                        _vm.saveButtonData.isLoading &&
                        _vm.saveButtonData.state === 1
                          ? 2
                          : _vm.saveButtonData.state,
                      "is-loading": _vm.saveButtonData.isLoading
                    }
                  }),
                  _vm._v(" "),
                  _c("cancel-button")
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b52f53a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b52f53a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Users/Cashiers/Form.vue
// module id = q4fC
// module chunks = 4